import { LogLevel, Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    /* Local Development */
    // redirectUri: "http://localhost:3000/",
    // postLogoutRedirectUri: "http://localhost:3000/",

    // redirectUri: "https://dpat1xgyqq390.cloudfront.net/",
    // postLogoutRedirectUri: "https://dpat1xgyqq390.cloudfront.net/",

    /* UAT */
    clientId: "a16a123a-fddf-45cb-a800-f7df3b85671e",
    authority:
      "https://login.microsoftonline.com/48d3c96a-92de-4f25-b0da-272a580b7c6b",
    redirectUri: "https://cxperspectives.aamc.com.au",
    postLogoutRedirectUri: "https://cxperspectives.aamc.com.au",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean,
      ) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};
